import { render, staticRenderFns } from "./PackageDialog.vue?vue&type=template&id=52cdda22&scoped=true"
import script from "./PackageDialog.vue?vue&type=script&lang=js"
export * from "./PackageDialog.vue?vue&type=script&lang=js"
import style0 from "./PackageDialog.vue?vue&type=style&index=0&id=52cdda22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52cdda22",
  null
  
)

export default component.exports